<template>
  <BaseEditModal
    :displayName="groupMaster?.name || 'Asset Group'"
    helpFileName="AssetGroup"
    itemtype="Asset Group"
    :tabs="tabs"
    :icon="'mdi-folder-multiple'"
    :masterObj="groupMaster"
    :saveFunc="saveGroup"
    :deleteFunc="deleteGroup"
    :instanceDeletable="true"
    @close="emit('close')"
    @locked="(bool) => emit('locked', bool)">
    <template v-slot:prepend-buttons>
      <!-- Custom buttons if needed -->
    </template>
  </BaseEditModal>
</template>

<script setup>
import { computed, ref } from 'vue';
import BaseEditModal from '../Shared/Modals/BaseEditModal.vue';
import GroupDetails from './AssetModalComponents/GroupDetails.vue';
import GroupAssets from './AssetModalComponents/GroupAssets.vue';
import { $http } from '../../stores/http';

const props = defineProps(['selected']);
const emit = defineEmits(['close', 'locked', 'refresh', 'open-asset']);

const groupMaster = computed(() => props.selected);

// Define tabs
const tabs = computed(() => [
  {
    id: 0,
    title: 'Details',
    icon: 'mdi-information',
    display: computed(() => true),
    component: GroupDetails,
    props: {},
    emits: {},
  },
  {
    id: 1,
    title: 'Assets',
    icon: 'mdi-folder-multiple',
    display: computed(() => true),
    component: GroupAssets,
    props: {},
    emits: {
      'asset-changed': () => {
        // Refresh the parent assets list
        emit('refresh');
      },
      'open-asset': (asset) => {
        // Pass through to parent to open EditAssetModal
        emit('open-asset', asset);
      },
    },
  },
]);

// Save function
const saveGroup = async (editedGroup) => {
  try {
    await $http(
      'PUT',
      '/update_asset_group',
      JSON.stringify({
        group_uid: editedGroup.uid,
        name: editedGroup.name,
        description: editedGroup.description,
      })
    );
    emit('refresh');
    return true; // Success
  } catch (error) {
    console.error('Failed to save asset group:', error);
    return false; // Failure
  }
};

// Delete function
const deleteGroup = async (groupToDelete) => {
  try {
    await $http('DELETE', `/delete_asset_group/${groupToDelete.uid}`);
    emit('refresh');
    emit('close');
    return true; // Success
  } catch (error) {
    console.error('Failed to delete asset group:', error);
    return false; // Failure
  }
};
</script>

<style scoped></style>
